import { useState } from "react";

import { Box, Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";

import { PageHeader } from "@/components/PageHeader";
import { ActivityProfileTab } from "@/pages/settings/ActivityProfileTab";
import { ExerciseModesTab } from "@/pages/settings/ExerciseModesTab";
import { SlotTemplatesTab } from "@/pages/settings/SlotTemplatesTab";
import { SpecialtiesTab } from "@/pages/settings/SpecialtiesTab";

export function SettingsPage() {
  const { t } = useTranslation();
  const [tab, setTab] = useState(0);

  return (
    <Box>
      <PageHeader title={t("settings.title")} subtitle={t("settings.subtitle")} helpTerm="parametres" />
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label={t("settings.tabSpecialties")} />
          <Tab label={t("settings.tabExerciseModes")} />
          <Tab label={t("settings.tabSlotTemplates")} />
          <Tab label={t("settings.tabActivityProfile")} />
        </Tabs>
      </Box>
      {tab === 0 && <SpecialtiesTab />}
      {tab === 1 && <ExerciseModesTab />}
      {tab === 2 && <SlotTemplatesTab />}
      {tab === 3 && <ActivityProfileTab />}
    </Box>
  );
}
